interface ILoginResponse{
    id: number,
    email: string,
    token: string,
    telefone?: string,
    cookies?: any
}

export const instanceOfILoginResponse = (object: any): object is ILoginResponse => {
    return 'id' in object &&
            'email' in object &&
            'token' in object
}

export default ILoginResponse